import React from 'react';

/**
 * BuildPreview.jsx — "Tell us what you need. See what we'd build."
 * Self-contained. Sits between AboutUs and BookingSection.
 *
 * A short invitation band: states the offer and sends the visitor to the
 * contact form. Deliberately uncluttered — the promise does the work.
 */
const BuildPreview = () => {
  const scrollToContact = () => {
    const el = document.getElementById('contact');
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    } else {
      window.location.href = '/#contact';
    }
  };

  return (
    <section id="what-we-build" className="cai-bpb">
      <div className="cai-bpb-inner">
        <div className="cai-bpb-card">
          <span className="cai-bpb-eyebrow"><i />See it before you commit</span>

          <h2 className="cai-bpb-h2">Tell us what you need. See what we&apos;d build.</h2>

          <p className="cai-bpb-sub">
            Describe the job eating the most time in your business. We&apos;ll come back with the
            automation we&apos;d put in place — what triggers it, what we&apos;d build, how long it
            takes, and what it gives you back. No obligation.
          </p>

          <button type="button" className="cai-bpb-cta" onClick={scrollToContact}>
            Tell us what you need
          </button>
        </div>
      </div>

      <style>{`
        .cai-bpb { background: #ECEAE3; padding: 96px 40px 0; }
        .cai-bpb-inner { max-width: 1000px; margin: 0 auto; }
        .cai-bpb-card { background: #fff; border-radius: 24px; padding: 60px 56px; box-shadow: 0 1px 3px rgba(0,0,0,0.05); text-align: center; }
        .cai-bpb-eyebrow { display: inline-flex; align-items: center; gap: 9px; background: #F6E7E1; border-radius: 999px; padding: 8px 17px; font-size: 11.5px; font-weight: 700; letter-spacing: 0.1em; text-transform: uppercase; color: #8C3219; margin-bottom: 22px; }
        .cai-bpb-eyebrow i { width: 8px; height: 8px; border-radius: 50%; background: #5E6B39; display: block; }
        .cai-bpb-h2 { margin: 0; font-size: clamp(30px, 4.2vw, 42px); font-weight: 800; letter-spacing: -0.028em; line-height: 1.08; color: #1A1A18; }
        .cai-bpb-sub { margin: 18px auto 0; font-size: 17.5px; line-height: 1.6; color: #5A564D; max-width: 60ch; }
        .cai-bpb-cta { font-family: inherit; font-size: 14.5px; font-weight: 700; letter-spacing: 0.03em; color: #fff; background: #C0492A; border: none; border-radius: 10px; padding: 16px 34px; cursor: pointer; margin-top: 32px; transition: background .18s ease; }
        .cai-bpb-cta:hover { background: #A53D22; }
        .cai-bpb-cta:focus-visible { outline: 3px solid #1A1A18; outline-offset: 3px; }
        @media (max-width: 860px) {
          .cai-bpb { padding: 64px 22px 0; }
          .cai-bpb-card { padding: 40px 26px; }
        }
      `}</style>
    </section>
  );
};

export default BuildPreview;
